module.exports = __webpack_public_path__ + "img/coupon-item-valid-bg.0e5519b3.png";